import React from "react";
import { NavLink } from "react-router-dom";

const Breadcrumb = ({ items }) => {
    return (
        <div className="d-flex align-items-center gap-2 mt-1" style={{ fontSize: '0.875rem', color: '#6c757d' }}>
            {items.map((item, index) => (
                <React.Fragment key={index}>
                    {typeof item === 'object' && item.path ? (
                        <NavLink to={item.path} style={{ color: '#6c757d', textDecoration: 'none' }}>
                            {item.label}
                        </NavLink>
                    ) : (
                        <span style={{ color: index === items.length - 1 ? '#212529' : '#6c757d' }}>
                            {typeof item === 'object' ? item.label : item}
                        </span>
                    )}
                    
                    {index < items.length - 1 && (
                        <i className="mdi mdi-chevron-right" style={{ fontSize: '1rem' }}></i>
                    )}
                </React.Fragment>
            ))}
        </div>
    );
};

export default Breadcrumb;
